import BEER_BOMB_SPLAT_IMAGE_URL from './beerSplat.png';
export { BEER_BOMB_SPLAT_IMAGE_URL };
export const BEER_BOMB_SPLAT_SPRITESHEET_DATA = {
    frames: {
        'beerSplat0001.png': {
            frame: { x: 1454, y: 1, w: 131, h: 157 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 57, y: 0, w: 131, h: 157 },
            sourceSize: { w: 226, h: 267 },
            anchor: { x: 0.533186, y: 0.65197 }
        },
        'beerSplat0002.png': {
            frame: { x: 1455, y: 327, w: 149, h: 156 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 46, y: 1, w: 149, h: 156 },
            sourceSize: { w: 226, h: 267 },
            anchor: { x: 0.533186, y: 0.65197 }
        },
        'beerSplat0003.png': {
            frame: { x: 813, y: 1, w: 167, h: 187 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 29, y: 9, w: 167, h: 187 },
            sourceSize: { w: 226, h: 267 },
            anchor: { x: 0.533186, y: 0.65197 }
        },
        'beerSplat0004.png': {
            frame: { x: 855, y: 190, w: 167, h: 183 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 29, y: 13, w: 167, h: 183 },
            sourceSize: { w: 226, h: 267 },
            anchor: { x: 0.533186, y: 0.65197 }
        },
        'beerSplat0005.png': {
            frame: { x: 511, y: 1, w: 195, h: 144 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 55, w: 195, h: 144 },
            sourceSize: { w: 226, h: 267 },
            anchor: { x: 0.533186, y: 0.65197 }
        },
        'beerSplat0006.png': {
            frame: { x: 657, y: 1, w: 193, h: 154 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 51, w: 193, h: 154 },
            sourceSize: { w: 226, h: 267 },
            anchor: { x: 0.533186, y: 0.65197 }
        },
        'beerSplat0007.png': {
            frame: { x: 435, y: 207, w: 204, h: 182 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 16, y: 39, w: 204, h: 182 },
            sourceSize: { w: 226, h: 267 },
            anchor: { x: 0.533186, y: 0.65197 }
        },
        'beerSplat0008.png': {
            frame: { x: 322, y: 1, w: 204, h: 187 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 16, y: 39, w: 204, h: 187 },
            sourceSize: { w: 226, h: 267 },
            anchor: { x: 0.533186, y: 0.65197 }
        },
        'beerSplat0009.png': {
            frame: { x: 1, y: 229, w: 226, h: 196 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 42, w: 226, h: 196 },
            sourceSize: { w: 226, h: 267 },
            anchor: { x: 0.533186, y: 0.65197 }
        },
        'beerSplat0010.png': {
            frame: { x: 1, y: 1, w: 226, h: 201 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 44, w: 226, h: 201 },
            sourceSize: { w: 226, h: 267 },
            anchor: { x: 0.533186, y: 0.65197 }
        },
        'beerSplat0011.png': {
            frame: { x: 1337, y: 332, w: 116, h: 160 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 72, y: 42, w: 116, h: 160 },
            sourceSize: { w: 226, h: 267 },
            anchor: { x: 0.533186, y: 0.65197 }
        },
        'beerSplat0012.png': {
            frame: { x: 1378, y: 165, w: 116, h: 160 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 72, y: 42, w: 116, h: 160 },
            sourceSize: { w: 226, h: 267 },
            anchor: { x: 0.533186, y: 0.65197 }
        },
        'beerSplat0013.png': {
            frame: { x: 1101, y: 342, w: 116, h: 161 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 72, y: 42, w: 116, h: 161 },
            sourceSize: { w: 226, h: 267 },
            anchor: { x: 0.533186, y: 0.65197 }
        },
        'beerSplat0014.png': {
            frame: { x: 1336, y: 1, w: 116, h: 162 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 72, y: 42, w: 116, h: 162 },
            sourceSize: { w: 226, h: 267 },
            anchor: { x: 0.533186, y: 0.65197 }
        },
        'beerSplat0015.png': {
            frame: { x: 1260, y: 167, w: 116, h: 163 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 72, y: 42, w: 116, h: 163 },
            sourceSize: { w: 226, h: 267 },
            anchor: { x: 0.533186, y: 0.65197 }
        },
        'beerSplat0016.png': {
            frame: { x: 1218, y: 1, w: 116, h: 164 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 72, y: 42, w: 116, h: 164 },
            sourceSize: { w: 226, h: 267 },
            anchor: { x: 0.533186, y: 0.65197 }
        },
        'beerSplat0017.png': {
            frame: { x: 1219, y: 338, w: 116, h: 165 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 72, y: 42, w: 116, h: 165 },
            sourceSize: { w: 226, h: 267 },
            anchor: { x: 0.533186, y: 0.65197 }
        },
        'beerSplat0018.png': {
            frame: { x: 1142, y: 170, w: 116, h: 166 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 72, y: 42, w: 116, h: 166 },
            sourceSize: { w: 226, h: 267 },
            anchor: { x: 0.533186, y: 0.65197 }
        },
        'beerSplat0019.png': {
            frame: { x: 1100, y: 1, w: 116, h: 167 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 72, y: 42, w: 116, h: 167 },
            sourceSize: { w: 226, h: 267 },
            anchor: { x: 0.533186, y: 0.65197 }
        },
        'beerSplat0020.png': {
            frame: { x: 1024, y: 172, w: 116, h: 168 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 72, y: 42, w: 116, h: 168 },
            sourceSize: { w: 226, h: 267 },
            anchor: { x: 0.533186, y: 0.65197 }
        },
        'beerSplat0021.png': {
            frame: { x: 982, y: 1, w: 116, h: 169 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 72, y: 42, w: 116, h: 169 },
            sourceSize: { w: 226, h: 267 },
            anchor: { x: 0.533186, y: 0.65197 }
        },
        'beerSplat0022.png': {
            frame: { x: 924, y: 375, w: 116, h: 175 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 72, y: 42, w: 116, h: 175 },
            sourceSize: { w: 226, h: 267 },
            anchor: { x: 0.533186, y: 0.65197 }
        },
        'beerSplat0023.png': {
            frame: { x: 737, y: 387, w: 116, h: 185 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 72, y: 42, w: 116, h: 185 },
            sourceSize: { w: 226, h: 267 },
            anchor: { x: 0.533186, y: 0.65197 }
        },
        'beerSplat0024.png': {
            frame: { x: 619, y: 198, w: 116, h: 195 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 72, y: 42, w: 116, h: 195 },
            sourceSize: { w: 226, h: 267 },
            anchor: { x: 0.533186, y: 0.65197 }
        },
        'beerSplat0025.png': {
            frame: { x: 317, y: 219, w: 116, h: 206 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 72, y: 42, w: 116, h: 206 },
            sourceSize: { w: 226, h: 267 },
            anchor: { x: 0.533186, y: 0.65197 }
        },
        'beerSplat0026.png': {
            frame: { x: 204, y: 1, w: 116, h: 216 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 72, y: 42, w: 116, h: 216 },
            sourceSize: { w: 226, h: 267 },
            anchor: { x: 0.533186, y: 0.65197 }
        },
        'beerSplat0027.png': {
            frame: { x: 199, y: 229, w: 116, h: 225 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 72, y: 42, w: 116, h: 225 },
            sourceSize: { w: 226, h: 267 },
            anchor: { x: 0.533186, y: 0.65197 }
        },
        'beerSplat0028.png': {
            frame: { x: 737, y: 196, w: 116, h: 189 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 72, y: 42, w: 116, h: 189 },
            sourceSize: { w: 226, h: 267 },
            anchor: { x: 0.533186, y: 0.65197 }
        },
        'beerSplat0029.png': {
            frame: { x: 1496, y: 160, w: 116, h: 134 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 72, y: 42, w: 116, h: 134 },
            sourceSize: { w: 226, h: 267 },
            anchor: { x: 0.533186, y: 0.65197 }
        }
    },
    animations: {
        animation: [
            'beerSplat0001.png',
            'beerSplat0002.png',
            'beerSplat0003.png',
            'beerSplat0004.png',
            'beerSplat0005.png',
            'beerSplat0006.png',
            'beerSplat0007.png',
            'beerSplat0008.png',
            'beerSplat0009.png',
            'beerSplat0010.png',
            'beerSplat0011.png',
            'beerSplat0012.png',
            'beerSplat0013.png',
            'beerSplat0014.png',
            'beerSplat0015.png',
            'beerSplat0016.png',
            'beerSplat0017.png',
            'beerSplat0018.png',
            'beerSplat0019.png',
            'beerSplat0020.png',
            'beerSplat0021.png',
            'beerSplat0022.png',
            'beerSplat0023.png',
            'beerSplat0024.png',
            'beerSplat0025.png',
            'beerSplat0026.png',
            'beerSplat0027.png',
            'beerSplat0028.png',
            'beerSplat0029.png'
        ]
    },
    meta: {
        app: 'https://www.codeandweb.com/texturepacker',
        version: '1.0',
        image: BEER_BOMB_SPLAT_IMAGE_URL,
        format: 'RGBA8888',
        size: { w: 1613, h: 504 },
        scale: '0.25',
        smartupdate: '$TexturePacker:SmartUpdate:18ae50fd36e9007ce27e452b20ded3c9:1fbcdcc1ba5215c3482dff58495ad344:995f8336914e7d2f444a816e2d29b31f$'
    }
};
